import React from 'react';
import ReactDOM from 'react-dom/client';
import { FormComponent, FormDocument, FormTemplate } from '@formbird/types';
import {FormbirdContextProvider} from './FormbirdContext';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

export const convertToCustomElement = (name: string, Component: any) => {
  if (customElements.get(name) !== undefined) {
    return;
  }
  class FtWrapper extends HTMLElement implements FormComponent {
    document!: FormDocument;
    template!: FormTemplate;
    fieldValue: any;
    fieldName!: string;
    formParameters: any;
    key!: number;
    message!: string;
    responsiveLayouts!: string;
    componentDefinition: any;

    connectedCallback(): void {
      const container = this;
      const shadowContainer = container.attachShadow({ mode: 'open' });
      const emotionRoot = document.createElement('style');
      const shadowRootElement = document.createElement('div');
      shadowContainer.appendChild(emotionRoot);
      shadowContainer.appendChild(shadowRootElement);

      const cache = createCache({
        key: 'css',
        prepend: true,
        container: emotionRoot,
      });
      cache.compat = true

      const shadowTheme = createTheme({
        components: {
          MuiPopover: {
            defaultProps: {
              container: shadowRootElement
            }
          },
          MuiPopper: {
            defaultProps: {
              container: shadowRootElement
            }
          },
          MuiModal: {
            defaultProps: {
              container: shadowRootElement
            }
          }
        },
        typography: {
          htmlFontSize: parseInt(getComputedStyle(document.querySelector('html')!).fontSize.replace('px', '')),
        },
      });


      if (!this.fieldValue && this.componentDefinition.defaultValue) {
        this.fieldValue = this.componentDefinition.defaultValue;
      }

      const ctx = {
        document: this.document,
        template: this.template,
        fieldValue: this.fieldValue,
        fieldName: this.fieldName,
        formParameters: this.formParameters,
        key: this.key,
        message: this.message,
        responsiveLayout: this.responsiveLayouts,
        componentDefinition: this.componentDefinition,
      };

      ReactDOM.createRoot(shadowRootElement).render(
          (
            <React.StrictMode>
              <CacheProvider value={cache}>
                <ThemeProvider theme={shadowTheme}>
                  <FormbirdContextProvider ctx={ctx}>
                    <Component {...ctx} />
                  </FormbirdContextProvider>
                </ThemeProvider>
              </CacheProvider>
            </React.StrictMode>
          ),
      );
    }
  }
  customElements.define(name, FtWrapper);
};
